import { BlueprintType } from '@constants'
import { IDocument, IPurchaseInvoice } from '@query'

export const defaultValuesForPurchaseInvoiceDocument = (
  invoice: IPurchaseInvoice,
  accountPayablesId: number
): Partial<IDocument> => {
  return {
    date: invoice?.invoicing_date,
    description: invoice?.sender_name,
    blueprint_type: BlueprintType.PURCHASE,
    attachment_ids: invoice?.original_attachment?.id ? [invoice.original_attachment.id] : [],
    tag_ids: invoice?.tag_ids || [],
    blueprint: {
      ...(accountPayablesId ? { credit_account_id: accountPayablesId } : {}),
      debet_entries: [
        {
          amount: invoice?.amount
        }
      ]
    }
  }
}
